import { render } from "./GSAPExampleNr1.vue?vue&type=template&id=2d062e71&scoped=true"
import script from "./GSAPExampleNr1.vue?vue&type=script&lang=js"
export * from "./GSAPExampleNr1.vue?vue&type=script&lang=js"

import "./GSAPExampleNr1.vue?vue&type=style&index=0&id=2d062e71&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d062e71"]])

export default __exports__